import { Box, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import { BaseMultiPermissionsForm, BasePermissionsForm } from '../index'

import constants from 'constants/index'

const AdminsForm = ({ permissions, handleChange, activeProfile, isEdit }) => {
  const { register } = useFormContext()

  const collaboratorProfileLists =
    constants.permissionsLists.collaboratorProfileLists

  return (
    <>
      <Box mt={2} mb={3}>
        <Typography variant="h5">Administradores</Typography>
      </Box>
      <BasePermissionsForm
        title="Atualizações"
        permissionsList={collaboratorProfileLists.lastUpdatesList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Colaboradores"
        permissionsList={collaboratorProfileLists.collaboratorList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Departamentos"
        permissionsList={collaboratorProfileLists.departmentList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Empresas"
        permissionsList={collaboratorProfileLists.companyList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      {/* Permissões inutilizadas mas com potencial para voltar no futuro */}
      {/* <BasePermissionsForm
        title="Exportar Informações"
        permissionsList={collaboratorProfileLists.exportInfoList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Exportar RIPD"
        permissionsList={collaboratorProfileLists.exportRipdList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      /> */}
      <BasePermissionsForm
        title="FAQs e Documentações"
        permissionsList={collaboratorProfileLists.faqsDocumentationList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Fornecedores"
        permissionsList={collaboratorProfileLists.companySupplierList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Grupos Advisor"
        permissionsList={collaboratorProfileLists.organizationList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Grupos Empresariais com Login SSO-SAML"
        permissionsList={collaboratorProfileLists.ssoCorporateGroupList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BasePermissionsForm
        title="Perfis de Colaboradores"
        permissionsList={collaboratorProfileLists.collaboratorProfileList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Perfis de Usuários"
        permissionsList={collaboratorProfileLists.clientProfileList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Políticas de Privacidade"
        permissionsList={collaboratorProfileLists.privacyPolicyList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Processos"
        permissionsList={collaboratorProfileLists.dataProcessList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Questionários por Empresa"
        permissionsList={collaboratorProfileLists.questionnaireByCompanyList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Regulamentos"
        permissionsList={collaboratorProfileLists.regulationList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Usuários"
        permissionsList={collaboratorProfileLists.userList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Projetos de Governança"
        permissionsList={collaboratorProfileLists.governanceProjectList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
      />
      <BaseMultiPermissionsForm
        title="Parceiros de Integração"
        permissionsLists={[
          {
            title: 'Parceiros',
            permissions: collaboratorProfileLists.integrationPartnerList,
          },
          {
            title: 'Tokens de integração',
            permissions: collaboratorProfileLists.integrationPartnerTokenList,
          },
          {
            title: 'Webhooks',
            permissions: collaboratorProfileLists.integrationPartnerWebhookList,
          },
          {
            title: 'Planos de upgrade',
            permissions: collaboratorProfileLists.integrationPartnerPlanList,
          },
        ]}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
    </>
  )
}

AdminsForm.propTypes = {
  register: PropTypes.func,
  permissions: PropTypes.object,
  handleChange: PropTypes.func,
  activeProfile: PropTypes.bool,
  isEdit: PropTypes.bool,
}

export default AdminsForm
